


































































































import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import LoginMixin from "#/mixins/loginMixin";
import Cookies from "js-cookie";

type Phase = "gating" | "selfReg" | "strict" | "requested" | "limit";

@Component
export default class DeviceGateArea extends Mixins(LoginMixin) {
  /** ログインゲートトークン */
  @Prop({ default: "" }) private token!: string;

  /** 端末制限モード(1:セルフ登録 2:厳格) */
  @Prop({ default: 0 }) private mode!: number;

  /** 許可端末数 */
  @Prop({ default: 0 }) private count!: number;

  /** ログイン完了 */
  @Emit() private finishLogin() {
    return;
  }

  /** ログイン画面へ戻る */
  @Emit() private backToLogin() {
    return;
  }

  private phase: Phase = "gating";
  private limitMessage = "登録可能なアカウント数の上限に達しています。";

  private mounted() {
    // 許可端末数が0件の場合、1回目の照合(get)をスキップして直接未登録フローへ
    if (this.count === 0) {
      this.onNoPasskey();
    } else {
      this.runGate();
    }
  }

  /** ゲート（アサーション）を実行する */
  private runGate() {
    this.phase = "gating";
    this.errorMessages = "";
    this.deviceGateBegin(
      window.base_url,
      window.axios,
      this.token,
      res => this.handleResult(res),
      () => this.onNoPasskey(),
      this.$openAlert
    );
  }

  private retryGate() {
    this.runGate();
  }

  /** パスキー未登録時：モードに応じて登録フローへ */
  private onNoPasskey() {
    if (this.mode === 1) {
      // セルフ登録：OTP(セキュリティコード)入力画面を表示
      this.phase = "selfReg";
    } else {
      // 厳格運用：コード入力 or 申請
      this.phase = "strict";
    }
  }

  /** セルフ登録：OTPコードを入力して生体認証・端末登録 */
  private registerSelfWithOtp() {
    this.errorMessages = "";
    this.deviceRegisterBegin(
      window.base_url,
      window.axios,
      this.token,
      this.activationCode,
      res => this.handleResult(res),
      this.$openAlert
    );
  }

  /** 厳格A：端末追加キーで登録 */
  private activateWithCode() {
    this.errorMessages = "";
    this.deviceRegisterBegin(
      window.base_url,
      window.axios,
      this.token,
      this.activationCode,
      res => this.handleResult(res),
      this.$openAlert
    );
  }

  /** 厳格B：管理者に申請（承認待ち登録） */
  private applyForApproval() {
    this.errorMessages = "";
    this.deviceRegisterBegin(
      window.base_url,
      window.axios,
      this.token,
      "",
      res => this.handleResult(res),
      this.$openAlert
    );
  }

  /** サーバレスポンスの共通処理 */
  private handleResult(res: AxiosResponse) {
    // 成功：JWT発行
    if (res.data.token && res.data.ref_token) {
      this.setCookie(res);
      return;
    }
    // 厳格B：申請受付
    if (res.data.device_request_accepted) {
      this.phase = "requested";
      return;
    }
    // 上限超過
    if (res.data.device_limit_exceeded) {
      this.limitMessage =
        res.data.message || "登録可能なアカウント数の上限に達しています。";
      this.phase = "limit";
      return;
    }
    // 未許可（コード入力 errorMessages 表示へ）
    if (res.data.device_access_denied || res.data.code === 400) {
      this.errorMessages = res.data.message || "処理に失敗しました。";
      this.phase = this.mode === 1 ? "selfReg" : "strict";
      return;
    }
  }

  /** クッキーに設定してログイン完了 */
  private setCookie(res: AxiosResponse) {
    window.token = res.data.token;
    Cookies.set("token", res.data.token, { domain: window.cookie_domain });
    window.reftoken = res.data.ref_token;
    Cookies.set("reftoken", res.data.ref_token, {
      domain: window.cookie_domain
    });
    this.finishLogin();
  }
}
